import { render, staticRenderFns } from "./BusinessReplySuggestion.vue?vue&type=template&id=5ef5afe0&"
import script from "./BusinessReplySuggestion.vue?vue&type=script&lang=js&"
export * from "./BusinessReplySuggestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports